import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of, tap} from 'rxjs';
import {AuthService} from 'app/core/auth/auth.service';
import {environment} from "../../../../../environments/environment";
import {LuzmoAsset, LuzmoAssetsResponse, LuzmoEmbedToken, LuzmoIqToken} from "../models/luzmo.models";

@Injectable({
    providedIn: 'root'
})
export class LuzmoService {

    private cachedAssets: LuzmoAsset[] | null = null;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
    ) {
    }

    getAssets(forceRefresh = false): Observable<LuzmoAssetsResponse> {
        if (this.authService.businessUser?.luzmoEnabled !== true) {
            this.cachedAssets = [];
            return of({assets: []});
        }
        if (!forceRefresh && this.cachedAssets) {
            return of({assets: this.cachedAssets});
        }
        return this.http.get<LuzmoAssetsResponse>(`${environment.BASE_URL}luzmo/assets`).pipe(
            tap((res) => {
                this.cachedAssets = (res?.assets ?? []).slice();
            })
        );
    }

    findCachedAsset(assetId: string): LuzmoAsset | undefined {
        return this.cachedAssets?.find(a => a.assetId === assetId);
    }

    createEmbedToken(assetId: string, assetType: string) {
        return this.http.post<LuzmoEmbedToken>(`${environment.BASE_URL}luzmo/embed-token`, {assetId, assetType});
    }

    createIqToken(assetId: string, assetType: string) {
        return this.http.post<LuzmoIqToken>(`${environment.BASE_URL}luzmo/iq-token`, {assetId, assetType});
    }
}
